import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import { setActiveClient } from "app/redux/client/activeClientSlice";
import {
  getUserPreferences,
  getUsersWithCompany,
  updateUserPreferences,
} from "app/services/clients/ClientService";

export default function ActiveClientGuard({ children }) {
  const dispatch = useDispatch();
  const activeClient = useSelector((state) => state.activeClient?.client);
  const [loading, setLoading] = useState(!activeClient);
  const initialized = useRef(false);

  useEffect(() => {
    if (activeClient || initialized.current) {
      return;
    }

    initialized.current = true;

    const initializeActiveClient = async () => {
      try {
        const clients = await getUsersWithCompany();

        if (!Array.isArray(clients) || clients.length === 0) {
          return;
        }

        let preferences = null;
        try {
          preferences = await getUserPreferences();
        } catch (error) {
          console.warn("Failed to load user preferences", error);
        }

        const preferredClient = clients.find(
          (client) => String(client.id) === String(preferences?.lastActiveClientId)
        );
        const nextClient = preferredClient || clients[0];

        dispatch(setActiveClient(nextClient));

        if (!preferredClient) {
          updateUserPreferences({ lastActiveClientId: nextClient.id }).catch(() => {
            console.warn("Failed to persist default active client preference");
          });
        }
      } catch (error) {
        console.warn("Failed to initialize active client", error);
      } finally {
        setLoading(false);
      }
    };

    initializeActiveClient();
  }, [activeClient, dispatch]);

  if (!activeClient && loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return children;
}
